export const CouponTypeEnum = {
  goods: 1, // 商品券
  freight: 2, // 运费券
  exchange: 3, // 兑换券
  parking: 9, // 停车券
  1: 'goods',
  2: 'freight',
  3: 'exchange',
  9: 'parking'
}

export const CouponTypeNames = {
  1: '商品券',
  2: '运费券',
  3: '兑换券',
  9: '停车券'
}

export const GoodsTypeNames = {
  1: '商城商品',
  2: '快速商品',
  3: '全部商品'
}

export const ExclusiveNames = {
  0: '通用券',
  1: 'app券',
  2: '小程序券',
  3: '分类券'
}

export const ButtonNames = {
  nowUse: '立即使用',
  used: '已使用',
  expired: '已过期',
  invalid: '已失效',
  refunded: '已退款',
  go: '去逛逛'
}

export const CouponStatusEnum = {
  all: -1, // 全部
  unused: 0, // 未使用 已生效
  used: 1, // 已使用
  expired: 2, // 已过期
  invalid: 3, // 已失效
  uneffective: 4, // 未使用 未生效
  refunded: 5, // 已退款
}

export const payTypeName= {
  'WECHATPAY':'微信支付',
  'ALIPAY':'支付宝'
}

export const joinGoodsTypeName={
    1 :'预制商品', 
    2 :'快速商品',
    3: '所有商品类型'
}
export const joinRangeTypeName={
    1 :'全场商品 ', 
    2 :'指定店铺',
    3: '指定品类',
    4 :'指定商品可用', 
    5 :'指定商场核销',
    6: '指定店铺核销',
    7: '指定秒杀',
}
export const  joinSeckillGoodsTypeName={
  1:'全部秒杀活动可用',
  2:'指定秒杀活动可用'
}

export const joinGoodsName={
    '13':'指定商场可用（全场商品可用）',
    '11':'全平台通用（仅限商城商品）',
    '12':'全平台通用（仅限快速商品）',
    '23':'指定店铺可用（全部商品可用）',
    '21':'指定店铺可用（仅限商城商品）',
    '22':'指定店铺可用（仅限快速商品）'
}

export const useChannelName={
    0 :'xxx',  //还得结合couponUseChannel字段判断，couponUseChannel.indexOf(3)>0为线上线下；couponUseChannel.indexOf(3)==-1 为线上
    '01':'线上商场使用',
    '01,2':'线上商场使用',
    '02':'线上商场使用',
    '01,2,3':'线上线下通用',
    1 :'线上商场使用', //APP
    2: '线上商场使用', //小程序
    3: '线下商场使用'
}

export const offlineJoinRangeTypeName={
    1 :'指定商场可用', 
    2 :'指定店铺可用',
    3: '指定店铺不可用'
}